// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingSidebarBottomContent_root__E0B53","title":"BookingSidebarBottomContent_title__RMmAj"};